"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BreadcrumbContext", {
  enumerable: true,
  get: function get() {
    return _context.default;
  }
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _queryString = _interopRequireDefault(require("query-string"));

var _lib = require("../../lib");

var _context = _interopRequireDefault(require("./context"));

var _Content = _interopRequireDefault(require("./Content"));

var _Update = _interopRequireDefault(require("./Update"));

var _withBreadcrumb = _interopRequireDefault(require("./withBreadcrumb"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Breadcrumb =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Breadcrumb, _PureComponent);

  function Breadcrumb(props) {
    var _this;

    _classCallCheck(this, Breadcrumb);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Breadcrumb).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "setComponentState", function (state) {
      return new Promise(function (resolve) {
        return _this.setState(state, function () {
          return resolve(state);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "checkPathExisted", function (key) {
      var pathMap = _this.state.pathMap;
      return (0, _lib.objHasOwnProperty)(pathMap, key) && !!pathMap[key];
    });

    _defineProperty(_assertThisInitialized(_this), "updatePathMap", function (excludes) {
      for (var _len = arguments.length, paths = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        paths[_key - 1] = arguments[_key];
      }

      return new Promise(function (resolve) {
        var location = _this.props.location;
        var pathMap = Object.assign.apply(Object, [{}, _this.state.pathMap].concat(paths));
        var data = Breadcrumb.getData(location, excludes, pathMap);

        _this.setState({
          pathMap: pathMap,
          data: data
        }, function () {
          return resolve({
            pathMap: pathMap,
            data: data
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updatePathState", function () {
      return new Promise(function (resolve) {
        var location = _this.props.location;
        var pathMap = Object.assign({}, _this.state.pathMap);

        if ((0, _lib.objHasKeys)(pathMap)) {
          var keys = Object.keys(pathMap);
          keys.forEach(function (k) {
            pathMap[k].visible = true;
            pathMap[k].loading = false;
          });
        }

        var data = Breadcrumb.getData(location, null, pathMap);

        _this.setState({
          pathMap: pathMap,
          data: data
        }, function () {
          return resolve({
            pathMap: pathMap,
            data: data
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (data) {
      _this.setState({
        data: data
      }, function () {
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            separator = _this$props.separator;

        if (onChange) {
          onChange({
            data: data,
            separator: separator
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnRouteChange", function (e, item) {
      var _this$props2 = _this.props,
          name = _this$props2.name,
          onRouteChange = _this$props2.onRouteChange;

      if (onRouteChange) {
        onRouteChange(e, {
          name: name,
          value: item.value,
          data: item
        });
      }
    });

    var _location = props.location;

    var _data = Breadcrumb.getData(_location);

    _this.state = {
      prevProps: {
        location: _location
      },
      data: _data,
      pathMap: {}
    };
    return _this;
  }

  _createClass(Breadcrumb, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          separator = _this$props3.separator,
          location = _this$props3.location;
      var _this$state = this.state,
          data = _this$state.data,
          pathMap = _this$state.pathMap;
      var context = {
        data: data,
        separator: separator,
        location: location,
        pathMap: pathMap,
        getPaths: Breadcrumb.getPaths,
        getPathKey: Breadcrumb.getPathKey,
        updatePathMap: this.updatePathMap,
        updatePathState: this.updatePathState,
        onChange: this.handleOnChange,
        onRouteChange: this.handleOnRouteChange,
        setContext: this.setComponentState,
        checkPathExisted: this.checkPathExisted
      };
      return _react.default.createElement(_context.default.Provider, {
        value: context
      }, children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps,
          pathMap = state.pathMap; // Compare the incoming prop to previous prop

      var location = props.location;
      var data = Breadcrumb.getData(location, null, pathMap);
      return {
        // Store the previous props in state
        prevProps: {
          location: location
        },
        data: prevProps.location !== location ? data : state.data
      };
    }
  }]);

  return Breadcrumb;
}(_react.PureComponent);

exports.default = Breadcrumb;

_defineProperty(Breadcrumb, "Content", _Content.default);

_defineProperty(Breadcrumb, "Update", (0, _withBreadcrumb.default)(_Update.default));

_defineProperty(Breadcrumb, "Consumer", _context.default.Consumer);

_defineProperty(Breadcrumb, "propTypes", {
  children: _propTypes.default.node.isRequired,
  name: _propTypes.default.string,
  separator: _propTypes.default.node,
  onChange: _propTypes.default.func,
  onRouteChange: _propTypes.default.func,
  // react-router props
  location: _propTypes.default.shape({
    pathname: _propTypes.default.string,
    search: _propTypes.default.string,
    hash: _propTypes.default.string
  }).isRequired
});

_defineProperty(Breadcrumb, "defaultProps", {
  name: null,
  separator: _react.default.createElement(_Icon.default, {
    name: _Icon.default.ChevronRight
  }),
  onChange: null,
  onRouteChange: null
});

_defineProperty(Breadcrumb, "getPaths", function (pathname) {
  return pathname.split('/').filter(function (i) {
    return i;
  });
});

_defineProperty(Breadcrumb, "getQueries", function (search) {
  var obj = _queryString.default.parse(search);

  var keys = Object.keys(obj);
  return keys.reduce(function (result, k) {
    var value = obj[k];

    if (value) {
      result.push({
        key: k,
        value: value
      });
    }

    return result;
  }, []);
});

_defineProperty(Breadcrumb, "getPathKey", function (pathname) {
  return "/".concat(Breadcrumb.getPaths(pathname).join('/'));
});

_defineProperty(Breadcrumb, "getData", function (location, excludes) {
  var pathMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var data = [];

  if (pathname) {
    var pathStrings = Breadcrumb.getPaths(pathname);

    if ((0, _lib.arrayHasItems)(pathStrings)) {
      data = data.concat(pathStrings.reduce(function (result, path, idx) {
        var currentPathStrings = pathStrings.slice(0, idx + 1);
        var url = "/".concat(currentPathStrings.join('/'));
        var pathObj = {
          title: path,
          value: url,
          // ignore first level
          visible: idx !== 0,
          loading: false
        }; // check path map

        if ((0, _lib.objHasKeys)(pathMap) && (0, _lib.objHasOwnProperty)(pathMap, url)) {
          var newPathObj = pathMap[url];

          if (newPathObj) {
            pathObj = Object.assign(pathObj, newPathObj);
          }
        }

        return result.concat(pathObj);
      }, []));
    }
  }

  if (search) {
    var searchStrings = Breadcrumb.getQueries(search);

    if ((0, _lib.arrayHasItems)(searchStrings)) {
      if ((0, _lib.arrayHasItems)(excludes)) {
        searchStrings = searchStrings.filter(function (_ref) {
          var key = _ref.key;
          return !excludes.includes(key);
        });
      } else if (excludes) {
        searchStrings = searchStrings.filter(function (_ref2) {
          var key = _ref2.key;
          return key !== excludes;
        });
      }

      data = data.concat(searchStrings.reduce(function (result, s, idx) {
        var currentSearchStrings = searchStrings.slice(0, idx + 1).reduce(function (res, searchS) {
          res[searchS.key] = searchS.value;
          return res;
        }, {});
        var url = "".concat(pathname, "?").concat(_queryString.default.stringify(currentSearchStrings));
        var pathObj = {
          title: s.value,
          value: url,
          visible: true,
          loading: false
        }; // check path map

        if ((0, _lib.objHasKeys)(pathMap) && (0, _lib.objHasOwnProperty)(pathMap, url)) {
          var newPathObj = pathMap[url];

          if (newPathObj) {
            pathObj = Object.assign(pathObj, newPathObj);
          }
        }

        return result.concat(pathObj);
      }, []));
    }
  }

  if (hash) {
    var hashStrings = Breadcrumb.getQueries(hash);

    if ((0, _lib.arrayHasItems)(hashStrings)) {
      if ((0, _lib.arrayHasItems)(excludes)) {
        hashStrings = hashStrings.filter(function (_ref3) {
          var key = _ref3.key;
          return !excludes.includes(key);
        });
      } else if (excludes) {
        hashStrings = hashStrings.filter(function (_ref4) {
          var key = _ref4.key;
          return key !== excludes;
        });
      }

      data = data.concat(hashStrings.reduce(function (result, s, idx) {
        var currentHashStrings = hashStrings.slice(0, idx + 1).reduce(function (res, hashS) {
          res[hashS.key] = hashS.value;
          return res;
        }, {});
        var url = "".concat(pathname, "?").concat(_queryString.default.stringify(currentHashStrings));
        var pathObj = {
          title: s.value,
          value: url,
          visible: true,
          loading: false
        }; // check path map

        if ((0, _lib.objHasKeys)(pathMap) && (0, _lib.objHasOwnProperty)(pathMap, url)) {
          var newPathObj = pathMap[url];

          if (newPathObj) {
            pathObj = Object.assign(pathObj, newPathObj);
          }
        }

        return result.concat(pathObj);
      }, []));
    }
  }

  return data;
});